module.exports = __webpack_public_path__ + "static/pm/img/steps-no-data.0d41fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/steps-no-data.png
// module id = mqhx
// module chunks = 1